export default __webpack_public_path__ + "static/media/categories2.de421d62.svg";